import { render } from "./preferences-page.vue?vue&type=template&id=694057ae&ts=true"
import script from "./preferences-page.vue?vue&type=script&lang=ts"
export * from "./preferences-page.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./preferences-page.vue?vue&type=custom&index=0&blockType=styles&scoped=true&lang=scss"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__